export type EmojiReaction = {
  emoji: string
  count: number
  reactedByCurrentUser: boolean
}

export function applyOptimisticReactionToggle(
  reactions: readonly EmojiReaction[] | null | undefined,
  emoji: string,
): EmojiReaction[] {
  const symbol = String(emoji || '').trim()
  const list = Array.isArray(reactions) ? [...reactions] : []
  if (!symbol) return list

  const index = list.findIndex((reaction) => reaction.emoji === symbol)
  if (index === -1) {
    return [
      ...list,
      {
        emoji: symbol,
        count: 1,
        reactedByCurrentUser: true,
      },
    ]
  }

  const current = list[index]
  const currentCount = Number.isFinite(Number(current.count)) ? Number(current.count) : 0
  const reacted = Boolean(current.reactedByCurrentUser)

  if (reacted) {
    const nextCount = Math.max(0, currentCount - 1)
    if (nextCount <= 0) {
      return list.filter((_, i) => i !== index)
    }
    return list.map((reaction, i) =>
      i === index
        ? {
            ...reaction,
            count: nextCount,
            reactedByCurrentUser: false,
          }
        : reaction,
    )
  }

  const nextCount = Math.max(0, currentCount) + 1
  return list.map((reaction, i) =>
    i === index
      ? {
          ...reaction,
          count: nextCount,
          reactedByCurrentUser: true,
        }
      : reaction,
  )
}
